export enum TaskViewTypes {
    User = 'User',
    Auth = 'Auth',
    Retrieve = 'Retrieve',
    Branch = "Branch"
}
